import { Component } from '@angular/core';

@Component({
  selector: 'portal-step-1-svg',
  standalone: true,
  templateUrl: './step-1.component.svg',
  styleUrl: './step-1.component.scss',
})
export class Step1SvgComponent {}
